var _path, _rect;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEcoBalls(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 16,
    viewBox: "0 0 18 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4682 8.016C13.4682 9.59333 13.0436 10.858 12.1942 11.81C11.3449 12.762 10.2156 13.238 8.80624 13.238C7.64891 13.238 6.68758 12.916 5.92224 12.272C5.15691 11.6187 4.69024 10.746 4.52224 9.654H6.28624C6.60358 11.054 7.42958 11.754 8.76424 11.754C9.66024 11.754 10.3509 11.4507 10.8362 10.844C11.3216 10.2373 11.6016 9.47667 11.6762 8.562H7.42024V7.148H11.6342C11.5036 6.31733 11.1956 5.636 10.7102 5.104C10.2342 4.56267 9.58091 4.292 8.75024 4.292C8.14358 4.292 7.62558 4.446 7.19624 4.754C6.76691 5.062 6.47758 5.48667 6.32824 6.028H4.57824C4.77424 4.98267 5.25491 4.18467 6.02024 3.634C6.79491 3.08333 7.69558 2.808 8.72224 2.808C9.70224 2.808 10.5562 3.05067 11.2842 3.536C12.0122 4.012 12.5582 4.642 12.9222 5.426C13.2862 6.20067 13.4682 7.064 13.4682 8.016Z",
    fill: "white"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 9,
    y: 1,
    width: 1,
    height: 14,
    fill: "white",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEcoBalls);
export default __webpack_public_path__ + "static/media/ecoBalls.1a5dcac0729f484ec49e7c22bbc466a3.svg";
export { ForwardRef as ReactComponent };